import { Clapperboard } from "lucide-react";

export default function FilmPsiCompare({ pm, compact = false }) {
  const fc = pm?.film_comparison;
  if (!fc || fc.score == null) return null;
  const psi = pm?.skill_index ?? 0;
  const diff = fc.diff ?? 0;
  const abs = Math.abs(diff).toFixed(1);
  let msg, color;
  if (diff > 0) {
    msg = `${abs} PSI above your rating — your film outperforms it`;
    color = "#22D3EE";
  } else if (diff < 0) {
    msg = `${abs} PSI below your rating — your rating is ahead of your latest film`;
    color = "#F59E0B";
  } else {
    msg = "a perfect match with your PSI";
    color = "#A3E635";
  }
  return (
    <div data-testid="film-psi-compare"
      className={`flex items-center gap-3 border border-pb-border bg-pb-elevated/40 ${compact ? "p-3 mt-3" : "p-4 mt-4"}`}>
      <Clapperboard className="w-4 h-4 shrink-0" style={{ color }} />
      <div className="min-w-0">
        <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">Film vs PSI — standalone comparison</div>
        <div className={`${compact ? "text-xs" : "text-sm"} text-zinc-300`}>
          Latest game film scored <b style={{ color }}>{fc.score}/100</b>{fc.psi_equiv != null ? <> (≈ PSI {fc.psi_equiv})</> : null} vs PSI <b>{psi}</b> — <span style={{ color }}>{msg}</span>.
        </div>
      </div>
    </div>
  );
}
